exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___3X9tk {\n  margin-bottom: 60px;\n}\n.title___1vB8i {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n}\n.img___2ibnU {\n  margin-top: 10px;\n}\n.terms___rciJZ {\n  margin-top: 40px;\n  margin-bottom: 0;\n}\n.noticeContainer___ouvaG {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  width: 100%;\n  max-width: 380px;\n  margin-top: 30px;\n  background: #EBF4F9;\n  border-radius: 4px;\n  padding: 20px 30px 20px 50px;\n  text-transform: none;\n}\n.noticeTitle___mxMNw {\n  font-size: 16px;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: 0;\n  line-height: 24px;\n  color: #21201f;\n  text-transform: none;\n  display: flex;\n  align-items: center;\n}\n.noticeBody___1Co92 {\n  font-size: 14px;\n  line-height: 22px;\n  color: #505050;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  letter-spacing: 0;\n  font-weight: normal;\n}\n.noticeIcon___3C6RT {\n  color: #189caa;\n  margin-left: -28px;\n  margin-right: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___3X9tk",
	"title": "title___1vB8i",
	"img": "img___2ibnU",
	"terms": "terms___rciJZ",
	"noticeContainer": "noticeContainer___ouvaG",
	"noticeTitle": "noticeTitle___mxMNw",
	"noticeBody": "noticeBody___1Co92",
	"noticeIcon": "noticeIcon___3C6RT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/ZoomConnect/zoomConnect.module.less
// module id = 2394
// module chunks = 68